<script lang="ts">
  import { wait, xhr } from "$app/utils"
  import { loadingIcon } from "$app/utils/icons"

  /**
   * A really simple autocomplete using svelte example from https://svelte.dev/repl/5734f123973d4682978427024ca90850?version=3.29.0
   */
  // import { countries } from './countriesData.js';
  // import Country from './Country.svelte';

  interface Props {
    plan: PlanType
    data: any[]
    onselected: (user: UserType) => void
  }

  let { plan, data, onselected }: Props = $props()

  /* FILTERING countres DATA BASED ON INPUT */
  let filteredData = []
  let focused = $state(false)
  // $: console.log(filteredData)

  let loading = $state(false)
  async function filterData(): Promise<void> {
    if (inputValue.trim().length < 3) {
      data = []
      return
    }

    try {
      loading = true

      const resp = await xhr.get(
        `/admin/plans/${plan.id}/coaches.json?q=${inputValue}`
      )

      data = resp.data
    } catch (e) {
      console.error(e)
    } finally {
      loading = false
    }
  }

  /* HANDLING THE INPUT */
  let searchInput: HTMLInputElement // use with bind:this to focus element
  let inputValue = $state("")

  async function blurInput(): Promise<void> {
    await wait(300)
    focused = false
  }

  function focusInput(): void {
    focused = true
    if (inputValue.trim().length < 3) {
      data = []
    }
  }
</script>

<div>
  <div class="relative">
    <input
      id="autocomplete-input"
      type="text"
      class="input w-full"
      placeholder="Add coach by searching name or email"
      bind:this={searchInput}
      bind:value={inputValue}
      oninput={filterData}
      onfocus={focusInput}
      onblur={blurInput}
    />
    <div class="absolute right-0 top-0 -mt-3" class:hidden={!loading}>
      {@html loadingIcon}
    </div>
  </div>

  <div class="relative">
    {#if data.length > 0}
      <ul
        class:hidden={!focused}
        class="absolute top-0 border text-left w-full z-40 bg-white"
      >
        <li
          class="py-2 px-4 w-full text-sm font-bold text-center bg-gray-200 text-gray-700 border-b border-gray-300"
        >
          Click on a name to add
        </li>
        {#each data as dat, i}
          <!-- svelte-ignore a11y_no_noninteractive_element_to_interactive_role -->
          <!-- svelte-ignore a11y_click_events_have_key_events -->
          <li
            class="py-2 px-4 w-full cursor-pointer hover:bg-gray-100"
            onclick={() => {
              onselected(dat)
              //focused = false
              inputValue = ""
            }}
            role="button"
            tabindex="0"
          >
            <div class="label-color">
              {dat.name}
            </div>
            <div class="text-sm">
              {dat.email}
            </div>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</div>
